import { ActionButton } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';

const HREF_NOTIFICATION_SUBSCRIPTION = '/profile';

/**
 * This is a simple button that sends the user to the profile page to
 * view the subscription options.
 */
export const SubscribeButton = () => {
  const subscribeButtonProps = useSubscribeButtonItemProps();

  return <ActionButton {...subscribeButtonProps} />;
};

export const useSubscribeButtonItemProps = () => {
  const [t] = useTranslation('translation');
  const { push } = useHistory();
  const isAuthenticatedToApi = useIsAuthenticated();
  const text = t('Subscribe', { ns: 'translation', defaultValue: 'Subscribe' });
  const title = isAuthenticatedToApi
    ? t('Subscribe to email notifications', {
        ns: 'translation',
        defaultValue: 'Subscribe to email notifications',
      })
    : t('Must be logged on to subscribe to email notifications', {
        ns: 'translation',
        defaultValue: 'Must be logged on to subscribe to email notifications',
      });

  return {
    iconProps: { iconName: 'Mail' },
    href: process.env.PUBLIC_URL + HREF_NOTIFICATION_SUBSCRIPTION,
    disabled: !isAuthenticatedToApi,
    text: text,
    title: title,
    onClick: e => {
      e.preventDefault();
      // Todo: come up with a clever way to open the panel too.
      push(HREF_NOTIFICATION_SUBSCRIPTION);
    },
  };
};
